import { render, staticRenderFns } from "./Switch.template.vue?vue&type=template&id=03e89c10&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e89c10",
  null
  
)

export default component.exports